const t = (key, label) => ({ key, label });
const m = (key, label) => ({ key, label, type: 'money' });
const q = (key, label) => ({ key, label, type: 'qty' });
const p = (key, label) => ({ key, label, type: 'pct' });
const b = (key, label) => ({ key, label, type: 'badge' });

const PO_GRN_HEAD = [t('po_number', 'PO Number'), t('po_date', 'PO Date'), t('grn_number', 'GRN Number'),
  t('grn_date', 'GRN Received Date'), t('supplier_name', 'Supplier Name'), t('sku', 'Product ID / SKU'), t('product_name', 'Product Name')];

export const RECON_COLS = [
  t('po_number', 'PO Number'), t('po_date', 'PO Date'), b('po_status', 'PO Status'), t('supplier_name', 'Supplier Name'),
  t('po_line_id', 'PO Line ID'), t('sku', 'Product ID / SKU'), t('product_name', 'Product Name'), t('category', 'Category'),
  t('uom', 'UoM'), q('pack_size', 'Pack Size'), q('po_qty', 'PO Ordered Qty'), t('grn_number', 'GRN Number'),
  t('grn_date', 'GRN Received Date'), q('grn_received_qty', 'GRN Received Qty'),
  q('grn_damaged_qty', 'GRN Damaged Qty'), q('grn_shortage_qty', 'GRN Shortage Qty'),
  q('cum_accepted', 'Cumulative Accepted'), q('pending_qty', 'Pending Qty'), q('excess_qty', 'Excess Received'),
  p('completion_pct', 'Receipt Completion %'), b('recon_status', 'Reconciliation Status'), t('exception_remarks', 'Exception Remarks'),
];

export const PPV_COLS = [
  ...PO_GRN_HEAD, m('po_unit_price', 'PO Unit Price'), m('grn_unit_price', 'Actual GRN Unit Price'), q('po_qty', 'PO Ordered Qty'), q('grn_received_qty', 'GRN Received Qty'),
  m('po_line_value', 'PO Line Value'), m('grn_received_value', 'GRN Received Value'),
  m('unit_price_variance', 'Unit Price Variance'), p('unit_price_variance_pct', 'Unit Price Var. %'),
  m('total_price_variance', 'Total Price Variance'), b('price_variance_status', 'Price Variance Status'),
  t('approval_remarks', 'Approval / Remarks'),
];

export const MRP_COLS = [
  ...PO_GRN_HEAD, m('po_mrp', 'PO MRP Snapshot'), m('grn_mrp', 'GRN MRP'), m('mrp_variance', 'MRP Variance'),
  p('mrp_change_pct', 'MRP Change %'), m('po_unit_price', 'PO Unit Price'), m('grn_unit_price', 'GRN Unit Price'),
  m('current_sp', 'Current Selling Price'), p('revised_margin_pct', 'Revised Margin %'), { key: 'margin_change_pp', label: 'Margin Change (pp)', type: 'qty' },
  m('margin_impact', 'Est. Margin Impact'), b('margin_status', 'Margin Status'),
  p('inward_margin_pct', 'Inward Margin % (vs GRN MRP)'), m('inward_margin_value', 'Inward Margin Value'),
  p('outward_margin_pct', 'Outward Margin % (vs GRN MRP)'), m('outward_margin_value', 'Outward Margin Value'),
];

export const SUPPLIER_COLS = [
  t('supplier_name', 'Supplier Name'), q('po_count', 'Total PO Count'), m('po_value', 'Total PO Value'),
  m('grn_received_value', 'GRN Received Value'), m('accepted_value', 'Accepted Value'), q('accepted_qty', 'Accepted Qty'),
  q('pending_qty', 'Pending Qty'), q('shortage_qty', 'Shortage Qty'), q('damaged_qty', 'Damaged Qty'),
  m('ppv', 'Purchase Price Variance'), p('ppv_pct', 'Price Variance %'), p('on_time_pct', 'On-Time Receipt %'),
  q('avg_delay_days', 'Avg Delivery Delay (Days)'), q('mrp_change_count', 'MRP Change Count'),
  q('open_exceptions', 'Open Exceptions'), q('score', 'Score'), b('status', 'Performance Status'),
];

export const EXCEPTION_COLS = [
  t('exception_id', 'Exception ID'), t('exception_date', 'Exception Date'), b('exception_type', 'Exception Type'),
  b('severity', 'Severity'), t('po_number', 'PO Number'), t('po_date', 'PO Date'), t('grn_number', 'GRN Number'),
  t('grn_date', 'GRN Received Date'), t('supplier_name', 'Supplier Name'), t('sku', 'Product ID / SKU'),
  t('product_name', 'Product Name'), q('po_qty', 'PO Ordered Qty'), q('grn_received_qty', 'GRN Received Qty'),
  m('po_unit_price', 'PO Unit Price'), m('grn_unit_price', 'Actual GRN Unit Price'),
  m('unit_price_variance', 'Unit Price Variance'), m('po_mrp', 'PO MRP'), m('grn_mrp', 'GRN MRP'), m('mrp_variance', 'MRP Variance'),
  m('financial_impact', 'Est. Financial Impact'), b('data_quality_flag', 'Data Quality Flag'), t('description', 'Exception Description'),
  b('resolution_status', 'Resolution Status'), t('assigned_to', 'Assigned To'), t('resolution_remarks', 'Resolution Remarks'),
  t('resolved_date', 'Resolved Date'),
];
